<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive> -->
        <router-view v-if="!$route.meta.link" :key="key" />
      <!-- </keep-alive> -->
    </transition>
    <transition name="handle">
      <div class="cc-work-order" v-if="$store.state.phone.showOrder">
         <Order></Order> 
      </div>
    </transition>
  </section>
</template>
<script>
import Order from "../../order";
export default {
    components: {
    Order,
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.app-main {
  // background-color: #f8fafc;
  padding: 10px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
.cc-work-order {
  position: sticky;
  bottom: 10px;
  z-index: 1999;
}
</style>
